<template>
  <div style="max-height: 500px; overflow: auto;" id="scroll_panel">
    <!-- 기본으로 해봄 -->
    <!-- <div v-bind:key="i" v-for="(s, i) in parsedHtml" v-bind:class="getClass(s)">
      <span style="min-width:10px">{{i + 1}}</span>
      <span :id="getClass(s) ? target_id : 'target'+i" v-bind:style="style(s)">
        {{s}}
      </span>
    </div> -->
    <!-- 테이블로 개선 -->
    <table class="table table-sm table-light">
      <tbody>
        <tr style="heigth:20px;" v-bind:id="'target_'+i+1" v-bind:key="i" v-for="(s, i) in parsedHtml" v-bind:class="getClass(s, i)">
          <th scope="row">{{i + 1}}</th>
          <th scope="row" v-bind:style="style(s)">{{s}}</th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
<style>
  /* required class */
  .heilith {
    background:black;
    color: red;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    /* padding: 5px; */
  }
</style>
